var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup41(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.66,
    height: 127.632,
    viewBox: "0 0 151.66 127.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(1054.14 -1575.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M143.652,633.228H11.979a9.994,9.994,0,0,0-9.993,9.993v42.8a9.994,9.994,0,0,0,9.993,9.993H34.417L38.285,679.1a11.051,11.051,0,0,1,10.825-8.629h57.411a11.057,11.057,0,0,1,10.825,8.629l3.86,16.912h22.446a10,10,0,0,0,9.994-9.993v-42.8a10,10,0,0,0-9.994-9.993m-31.036,28.315H40.368a3.749,3.749,0,0,1,0-7.5h72.248a3.749,3.749,0,0,1,0,7.5",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M17.219,626.211H138.4a9.995,9.995,0,0,0,9.168-13.974l-6.312-14.521a10,10,0,0,0-9.168-6.013H114.947l-1.424,8.591a10.062,10.062,0,0,1-9.956,8.449H54.538a10.063,10.063,0,0,1-9.956-8.449L43.158,591.7H23.531a9.981,9.981,0,0,0-9.161,6.013L8.058,612.237a9.992,9.992,0,0,0,9.161,13.974",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M113.523,696.013l-3.486-15.241a3.589,3.589,0,0,0-3.516-2.8H49.11a3.6,3.6,0,0,0-3.523,2.8l-3.479,15.241-.652,2.849a3.615,3.615,0,0,0,3.516,4.415h65.68a3.615,3.615,0,0,0,3.523-4.415Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M48.713,591.7l1.275,7.692a4.6,4.6,0,0,0,4.55,3.868h49.029a4.6,4.6,0,0,0,4.551-3.868l1.274-7.692,1.769-10.69a4.62,4.62,0,0,0-4.55-5.368H51.494a4.62,4.62,0,0,0-4.55,5.368Z",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup41);
export default __webpack_public_path__ + "static/media/Group 41.ccd24aab6ece5a14ce4b5e0b7817862f.svg";
export { ForwardRef as ReactComponent };